import i18next from 'i18next';

export function addError(input, message = 'error') {
  input.classList.add('invalid');
  const error = input.parentElement.querySelector('.js-form-error');
  if (!error) return;
  error.innerText = i18next.t(message);
}

export function removeError(input) {
  if (!input.classList.contains('invalid')) return;
  input.classList.remove('invalid');
  const error = input.parentElement.querySelector('.js-form-error');
  if (!error) return;
  error.innerText = '';
}

export function removeAllErrors(form) {
  const inputsArr = form.querySelectorAll('.form-control');
  inputsArr.forEach((input) => {
    removeError(input);
  })
}